import { ACTION_TYPES } from 'store/details/types';

export const resetState = () => ({
  type: ACTION_TYPES.RESET,
});

export const removeAdmin = (name: string) => ({
  type: ACTION_TYPES.REMOVE_ADMIN,
  payload: name,
});
